<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Multiselect from 'vue-multiselect'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import vue2Dropzone from 'vue2-dropzone'
import axios from 'axios'
import { axiosGetPost } from '@router/axiosGetPost'
import WaitingStatus from '@/src/components/WaitingStatus'
import moment from 'moment'

export default {
  page: {
    title: 'Importation FCL',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
    vueDropzone: vue2Dropzone,
    WaitingStatus,
  },
  props: {
    user: {
      type: [Array, Object],
      default: function() {
        return {}
      },
    },
  },
  data() {
    return {
      title: 'Importation FCL',
      items: [
        {
          text: 'Barracuda',
          href: '/',
        },
        {
          text: 'Accounts FCL',
          href: '/accounts/fcl',
        },
        {
          text: 'Import',
          active: true,
        },
      ],
      request_id: this.$route.params.id,
      errors: [],
      carriers: [],
      currencies: [],
      currencyOptions: [
        { text: 'Values Only', value: 1 },
        { text: 'Values With Currency', value: 2 },
        { text: 'Specific', value: 3 },
      ],
      validation: null,
      contractName: null,
      companyUser: null,
      direction: null,
      contractCarriers: null,
      equipment: null,
      loandingData: false,
      waitingStatusC: false,
      seletedOptions: {
        carrierActive: true,
        typeDestinyActive: true,
        currencySelected: 1,
        chargeDiff: 'FREIGHT',
        carrier: null,
        typeDestiny: { id: 3, name: 'freight' },
        currency: { id: 149, name: 'USD' },
        fileName: null,
        dropzoneOptions: {
          url: process.env.VUE_APP_RUTA_API + 'cargofive/upload_file',
          thumbnailWidth: 150,
          maxFilesize: 10.0,
          dictDefaultMessage:
            "<i class='uil uil-cloud-upload'></i> Upload File",
          maxFiles: 1,
          addRemoveLinks: true,
          acceptedFiles: '.xls, .xlsx',
          headers: {
            Authorization: this.user.token,
          },
        },
      },
      module: 'FCL',
      message: null,
      messageBool: false,
    }
  },
  watch: {
    // call again the method if the route changes
    $route: 'getData',
  },
  created() {
    // fetch the data when the view is created and the data is
    // already being observed
    this.getData()
  },
  methods: {
    getData() {
      // replace `getPost` with your data fetching util / API wrapper
      axiosGetPost(
        'get',
        '/contracts/import_contract/' + this.request_id,
        {},
        'Load Data Importation FCL'
      ).then((data) => {
        this.carriers = data.carriers
        this.seletedOptions.carrier = data.contractCarriers[1][0]

        this.currencies = data.currencies
        this.validation = data.validation
        this.contractName = data.contractName
        this.companyUser = data.companyUser
        this.direction = data.direction
        this.equipment = data.equipment
        this.contractCarriers = data.contractCarriers[0]
        if (
          this.contractCarriers == 'ALL' ||
          this.contractCarriers.split(',').length > 1
        ) {
          this.seletedOptions.carrierActive = false
        }

        return data
      })
    },
    redirectGoodAndFail() {
      axiosGetPost('post', '/contracts/getStatusTask/' + this.request_id).then(
        (response) => {
          let data = {
            name: 'goodandfails',
            params: { id: this.request_id, module: 'FCL' },
          }
          if (response.data !== true) {
            data = {
              name: 'reviews_module',
              params: { id: this.request_id, module: 'FCL' },
            }
          }
          this.$router.push(data)
          return response
        }
      )
    },
    saveData() {
      // replace `getPost` with your data fetching util / API wrapper
      this.loandingData = true
      this.messageBool = false
      this.message = null
      axiosGetPost(
        'post',
        '/contracts/import_contract/' + this.request_id,
        {
          selectedOptions: this.seletedOptions,
        },
        'PUSH Importation FCL'
      ).then((data) => {
        if (data.data === true) {
          this.waitingStatusC = true
          this.$toastr.s('Successful. In process.')
        } else {
          this.loandingData = false
          this.messageBool = true
          this.message = data.messages + '. Error File.'
          this.$toastr.e(data.messages + '. Error File.')
        }
        return data
      })
    },
    removeFile() {
      const dataDic = {
        filename: this.seletedOptions.fileName,
      }
      axiosGetPost(
        'post',
        '/cargofive/delete_file',
        dataDic,
        'Drop file Dropzone Importation FCL'
      ).then((response) => {
        let data = response.data
        if (data.success === true) {
          this.seletedOptions.fileName = null
        } else {
          this.seletedOptions.fileName = null
          this.$toastr.e('Error Delete in Server. Error: ' + data.error)
        }
        return data
      })
    },
    vsuccess(file, response) {
      this.seletedOptions.fileName = response.file_name
    },
    validateForm() {
      let formAction = false
      let message = ''
      this.errors = []
      if (!this.seletedOptions.chargeDiff) {
        this.errors.push('The Charge Diff is required.')
      }
      if (!this.seletedOptions.fileName) {
        this.errors.push('The File is required.')
      }

      if (this.errors.length > 0) {
        formAction = true
        // Send message to browser screen
        this.errors.forEach((element) => {
          message += '<li> ' + element + ' </li>'
        })
        this.$toastr.e("Error : <ul color='yellow'>" + message + '</ul>')
      }

      if (formAction === false) {
        this.saveData()
        // alert('se ejecuta saveData()')
      }
    },
    test() {
      console.log(this.seletedOptions)
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <form action>
            <div class="card-body">
              <h4 class="header-title mb-3 mt-0"
                >Import Contract / Request: {{ request_id }} -
                <i v-bind="{ class: equipment }"> {{ equipment }}</i>
              </h4>
              <h4 v-if="messageBool" style="color:brown"> {{ message }}</h4>
              <div v-if="loandingData === false">
                <div class="form-group">
                  <div class="row">
                    <div class="col-md col-md-4">
                      <label for="name"> Name Contract </label>
                      <b-form-input
                        id="name"
                        v-model="contractName"
                        value
                        placeholder="Write name"
                        readonly
                      >
                      </b-form-input>
                    </div>
                    <div class="col-md col-md-2">
                      <label for="name"> Validation </label>
                      <b-form-input
                        id="name"
                        v-model="validation"
                        value
                        placeholder="Write name"
                        readonly
                      >
                      </b-form-input>
                    </div>
                    <div class="col-md col-md-2">
                      <label for="name"> Company User </label>
                      <b-form-input
                        id="name"
                        v-model="companyUser"
                        value
                        placeholder="Write name"
                        readonly
                      >
                      </b-form-input>
                    </div>
                    <div class="col-md col-md-2">
                      <label for="name"> Direction </label>
                      <b-form-input
                        id="name"
                        v-model="direction"
                        value
                        placeholder="Write name"
                        readonly
                      >
                      </b-form-input>
                    </div>
                    <div class="col-md col-md-2">
                      <label for="name"> Carriers </label>
                      <b-form-input
                        id="name"
                        v-model="contractCarriers"
                        value
                        placeholder="Write name"
                        readonly
                      >
                      </b-form-input>
                    </div>
                  </div>
                </div>
                <hr />
                <div class="form-group">
                  <div class="row">
                    <div class="col-md col-md-2">
                      <div class="form-group mt-3 mt-sm-0">
                        <label for="name"> Charge Diff</label>
                        <b-form-input
                          id="name"
                          v-model="seletedOptions.chargeDiff"
                          value
                          placeholder="Write name"
                          required
                        >
                        </b-form-input>
                      </div>
                    </div>
                    <div class="col-md col-md-2">
                      <div class="form-group mt-3 mt-sm-0">
                        <b-form-checkbox
                          v-model="seletedOptions.carrierActive"
                          name="check-button"
                          switch
                        >
                          Carrier Not Included
                        </b-form-checkbox>
                        <multiselect
                          id="carrier"
                          v-model="seletedOptions.carrier"
                          :options="carriers"
                          placeholder="Select one"
                          label="name"
                          track-by="name"
                          class="form-group mt-3 mt-sm-2"
                          required
                          v-bind="{
                            disabled: seletedOptions.carrierActive
                              ? false
                              : true,
                          }"
                        ></multiselect>
                      </div>
                    </div>

                    <div class="col-md col-md-5">
                      <div class="form-group row">
                        <div class="col-sm-7">
                          <label for="">Currency Options</label>
                          <b-form-group v-slot="{ ariaDescribedby }">
                            <b-form-radio-group
                              id="radio-group-1"
                              v-model="seletedOptions.currencySelected"
                              :options="currencyOptions"
                              :aria-describedby="ariaDescribedby"
                              name="radio-options"
                            >
                            </b-form-radio-group>
                          </b-form-group>
                        </div>
                        <div class="col-md-4">
                          <multiselect
                            id="currency"
                            v-model="seletedOptions.currency"
                            :options="currencies"
                            placeholder="Select one"
                            label="name"
                            track-by="name"
                            class=" mt-3 mt-sm-3"
                            v-bind="{
                              disabled:
                                seletedOptions.currencySelected === 3
                                  ? false
                                  : true,
                            }"
                          >
                          </multiselect>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xl-12 col-sm-12">
                      <div class="form-group mt-1 mt-sm-0">
                        <vue-dropzone
                          id="dropzone"
                          ref="myVueDropzone"
                          :options="seletedOptions.dropzoneOptions"
                          :destroyDropzone="false"
                          @vdropzone-removed-file="removeFile"
                          @vdropzone-success="vsuccess"
                        >
                          <div class="text-center">
                            <i class="h1 text-muted uil-cloud-upload"></i>
                            <h3>Drop files here or click to upload.</h3>
                            <span class="text-muted font-size-13">
                              (This is just a demo dropzone. Selected files are
                              <strong>not</strong> actually uploaded.)
                            </span>
                          </div>
                        </vue-dropzone>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xl-5 col-sm-5"></div>
                    <div class="col-xl-2 col-sm-2">
                      <div class="form-group mt-1 mt-sm-0">
                        <button
                          type="button"
                          name="save"
                          class="btn btn-primary form-control"
                          @click.prevent="validateForm"
                          >Save</button
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else-if="loandingData === true && waitingStatusC === true">
                <WaitingStatus
                  :request-id="request_id"
                  :reload-time="10"
                  @postevent="redirectGoodAndFail"
                  has-post-event
                  url="/contracts/getStatusTask/"
                />
              </div>
              <div
                v-else-if="loandingData === true && waitingStatusC === false"
                class="row align-items-center justify-content-center"
                style="height: 300px"
              >
                <div class="col-12 col-md-8 text-center">
                  <b-spinner
                    label="Loading..."
                    variant="primary"
                    class="ml-3"
                  ></b-spinner>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.vue-dropzone > .dz-preview .dz-remove {
  margin-left: 13px;
  padding: 33px;
  bottom: 55px;
}

.DRY {
  color: blue;
}
</style>
